import { HapticFeedbackTypes } from './hapticFeedback.types';

const VIBRATE_PATTERNS: Record<HapticFeedbackTypes, VibratePattern> = {
  selection: 100,
  impactLight: 100,
  impactMedium: 100,
  impactHeavy: 100,
  rigid: 100,
  soft: 100,
  notificationSuccess: 100,
  notificationWarning: 100,
  notificationError: 100,
  clockTick: 100,
  contextClick: 100,
  keyboardPress: 100,
  keyboardRelease: 100,
  keyboardTap: 100,
  longPress: 100,
  textHandleMove: 100,
  virtualKey: 100,
  virtualKeyRelease: 100,
  effectClick: 100,
  effectDoubleClick: 100,
  effectHeavyClick: 100,
  effectTick: 100,
};

export const HapticFeedback = {
  trigger: (type: HapticFeedbackTypes) =>
    navigator?.vibrate(VIBRATE_PATTERNS[type]),
};
